import { IAttendance } from '../../../shared/interfaces/attendance/IAttendance';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { ATTENDANCE_URL } from '../../../utils/api/endpoints';

export const AdminAttendanceService = {
  start: (startDate: string) => requests.post(ATTENDANCE_URL, { startDate }),
  end: (endDate: string, id: number, isManual?: boolean) =>
    requests.put(`${ATTENDANCE_URL}/${id}`, { endDate, isManual }),
  getAll: (pagination: IPagination): Promise<IBaseModel<IAttendance[]>> =>
    requests.get(ATTENDANCE_URL, pagination),
  delete: (attendanceId: number) =>
    requests.delete(`${ATTENDANCE_URL}/${attendanceId}`),
};
